/* eslint-disable react/button-has-type */

import React from 'react';

import { Container, Grid, makeStyles, Typography } from '@material-ui/core';

import IconClose from '../../assets/images/ic-close-round.svg';
import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles((theme) => {
  return {
    buttonNext: {
      width: '180px',
    },
    container: {
      background: '#FFFFFF',
      borderRadius: '8px',
      padding: '20px',
      width: '288px',
      [theme.breakpoints.up('lg')]: {
        padding: '30px',
        width: '480px',
      },
    },
    containerDescription: {
      margin: '14px 0px 10px',
      [theme.breakpoints.up('lg')]: {
        margin: '14px 0px 24px',
      },
    },
    containerTitle: {
      position: 'relative',
    },
    iconClose: {
      cursor: 'pointer',
      height: '24px',
      position: 'absolute',
      right: '-8px',
      top: '-16px',
      width: '24px',
    },
    typographyDescription: {
      color: '#999999 ',
      fontSize: '12px',
      marginBottom: '0px',
      textAlign: 'left',
    },
    typographyStep: {
      color: '#999999',
      fontSize: '12px',
      lineHeight: '14px',
      marginBottom: '0px',
    },
    typographyTitle: {
      color: theme.palette.primary.main,
      fontSize: '22px',
      fontWeight: 600,
      lineHeight: '24px',
      marginBottom: '0px',
      textAlign: 'left',
    },
  };
});

export default ({ continuous, index, step, totalStep, backProps, closeProps, primaryProps, tooltipProps, additionalStep = 0, additionalTotalStep = 0 }) => {
  const classes = useStyles();

  return (
    <Container {...tooltipProps} className={classes.container}>
      <Grid container className={classes.containerTitle} justify="space-between" alignItems="center">
        <Grid item>
          <Typography className={classes.typographyTitle}>{step.title}</Typography>
        </Grid>

        <img {...closeProps} src={IconClose} className={classes.iconClose} alt="Close Icon" />
      </Grid>

      <div className={classes.containerDescription}>
        <Typography className={classes.typographyDescription}>{step.content}</Typography>
      </div>

      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Typography className={classes.typographyStep}>
            Step {index + 1 + additionalStep}/{totalStep + additionalTotalStep}
          </Typography>
        </Grid>
        <Grid item>
          <LoadingButton {...primaryProps} variant="contained" color="primary" className={classes.buttonNext}>
            {step.locale.next}
          </LoadingButton>
        </Grid>
      </Grid>
    </Container>
  );
};
